/* ============================================================
   BLANKPILL — SHARED product fetch (perf)
   Every module below needs the same /products/{handle}.js data.
   Previously each fetched it independently (2+ identical network
   requests per product page) which added mobile load lag. This
   single shared, de-duped promise means the file is fetched ONCE
   and reused everywhere. Cached on window so all IIFEs share it.
   ============================================================ */
(function () {
  if (window.__bpProductFetch) return;
  window.__bpProductFetch = function () {
    if (window.__bpProductData) return Promise.resolve(window.__bpProductData);
    if (window.__bpProductPromise) return window.__bpProductPromise;
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return Promise.resolve(null);
    window.__bpProductPromise = fetch('/products/' + m[1] + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) { window.__bpProductData = p; return p; })
      .catch(function () { return null; });
    return window.__bpProductPromise;
  };
})();


/* BlankPill: on mobile, scroll fully to top when a variant is selected
   so the shopper sees the product image / color change. Desktop left alone. */
(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function scrollTop() {
    if (!isMobile()) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }

  function bind() {
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (
        t &&
        (t.matches('input[type="radio"]') ||
          t.closest('.variant-option') ||
          t.closest('variant-picker'))
      ) {
        setTimeout(scrollTop, 60);
      }
    });
    document.addEventListener('click', function (e) {
      var label = e.target.closest('.variant-option__button-label, .variant-option label');
      if (label) setTimeout(scrollTop, 120);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  document.addEventListener('shopify:section:load', bind);
})();



/* ============================================================
   BLANKPILL — product page: low-stock urgency + trust badges
   - Low-stock: reads the selected variant's inventory from
     /products/{handle}.js and shows "Only N left" when low.
   - Trust badges: ships in 48hr, secure checkout, easy returns —
     injected under the Add to Cart button, hand-drawn SVG icons.
   Reversible: this is appended to blankpill-product.js (product
   templates only). Remove this block to undo.
   ============================================================ */
(function () {
  'use strict';

  var LOW_STOCK_THRESHOLD = 10; // show urgency when fewer than this remain

  function handle() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  // Use the shared, de-duped fetch (one request per page for all modules).
  function getProduct() {
    return window.__bpProductFetch();
  }

  function currentVariantId() {
    var input = document.querySelector('input[name="id"], select[name="id"], [name="id"]');
    if (input && input.value) return parseInt(input.value, 10);
    var url = new URL(window.location.href);
    if (url.searchParams.get('variant')) return parseInt(url.searchParams.get('variant'), 10);
    return null;
  }

  function renderLowStock(variant) {
    var anchor = document.querySelector('.buy-buttons-block, product-form-component, .product-form');
    if (!anchor) return;
    var existing = document.getElementById('bp-low-stock');
    if (existing) existing.remove();
    if (!variant) return;

    // Only show when inventory is tracked, finite, and low (but in stock)
    var qty = (typeof variant.inventory_quantity === 'number') ? variant.inventory_quantity : null;
    var policy = variant.inventory_management; // null when not tracked
    if (!variant.available) return;
    if (policy == null || qty == null) return; // untracked → don't fake scarcity
    if (qty <= 0 || qty >= LOW_STOCK_THRESHOLD) return;

    var el = document.createElement('div');
    el.id = 'bp-low-stock';
    el.className = 'bp-low-stock';
    el.innerHTML = '<span class="bp-low-stock__dot"></span>Selling fast — only <strong>' + qty + ' left</strong> in this size';
    anchor.parentNode.insertBefore(el, anchor);
  }

  function renderBenefits() {
    if (document.getElementById('bp-benefits')) return;
    // Prefer to sit ABOVE the "Hurry up! Sale ends in" countdown timer.
    // The countdown is a Section Store block; find it and anchor above it.
    var countdown =
      document.querySelector(
        '[class*="countdown"], [class*="timer"], [id*="countdown"], [id*="timer"], [class*="sale-ends"]'
      );
    // Walk up to the countdown's section/block wrapper so we insert
    // before the WHOLE timer unit, not inside it.
    var anchor = null;
    if (countdown) {
      anchor = countdown.closest('.shopify-block, .shopify-section, [class*="block"]') || countdown;
    }
    // Fallback: above the variant/buy block (old behavior).
    if (!anchor) {
      anchor = document.querySelector('product-form-component, .buy-buttons-block, .product-form');
    }
    if (!anchor) return;
    var el = document.createElement('div');
    el.id = 'bp-benefits';
    el.className = 'bp-benefits';
    var check =
      '<svg class="bp-benefits__check" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
        '<path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';
    var items = [
      'Backed by 100+ happy customers',
      '100% heavyweight cotton',
      'Original art, printed to order',
      'Free shipping on orders $60+'
    ];
    var rows = items.map(function (t) {
      return '<li class="bp-benefits__item"><span class="bp-benefits__disc">' + check + '</span>' + t + '</li>';
    }).join('');
    el.innerHTML =
      '<ul class="bp-benefits__list">' + rows + '</ul>' +
      '<div class="bp-benefits__status">' +
        '<span class="bp-benefits__pulse"></span>' +
        '<span class="bp-benefits__status-text">In stock &amp; ready to ship</span>' +
      '</div>';
    // insert just before the buy/variant block so it reads top-to-bottom:
    // benefits → variant → ATC → buy with shop → ETA
    anchor.parentNode.insertBefore(el, anchor);
  }

  function renderTrust() {
    if (document.getElementById('bp-trust')) return;
    var anchor = document.querySelector('.buy-buttons-block, product-form-component, .product-form');
    if (!anchor) return;
    var el = document.createElement('div');
    el.id = 'bp-trust';
    el.className = 'bp-trust';

    // Hand-drawn marker-style SVGs (rough strokes, round caps) using
    // currentColor so they pick up the acid accent. Matches the chudjak vibe.
    var icoBolt =
      '<svg class="bp-trust__svg" viewBox="0 0 32 32" fill="none" aria-hidden="true">' +
        '<path d="M18.5 3.5c-.4 2-3.8 9.2-7.6 12.1-.6.5-.3 1.2.5 1.2 1.7.1 4.3.1 5.2.2.6 0 .8.4.6 1.1-.8 2.6-2 7-2.2 9.4-.05.6.5.9.95.45 2.6-2.7 8.6-9.6 11.1-13.2.4-.6.05-1.2-.7-1.2-1.6-.05-3.9-.1-5-.15-.6-.03-.85-.45-.6-1.1.8-2.2 1.7-5.6 2-7.9.08-.65-.5-1-.95-.5-.9 1-2.4 2.8-3.85 4.4" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" stroke-linecap="round"/>' +
      '</svg>';
    var icoLock =
      '<svg class="bp-trust__svg" viewBox="0 0 32 32" fill="none" aria-hidden="true">' +
        '<path d="M8.5 14.5c-.3 0-.7.3-.7.8.1 3 .1 8 .3 10.4 0 .6.4.9 1 .9 3.4.15 9.8.15 13.2 0 .6-.02 1-.35 1-.95.15-2.5.2-7.3.2-10.3 0-.5-.35-.8-.8-.85-4-.2-10.4-.2-14.4 0" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" stroke-linecap="round"/>' +
        '<path d="M11 14c-.1-1.8-.3-4.5.4-6.2C12.2 5.7 14 4.6 16 4.6c2.1 0 3.9 1.2 4.6 3.3.6 1.7.5 4.3.4 6.1" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" stroke-linecap="round"/>' +
        '<path d="M16 19v3.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
      '</svg>';
    var icoReturn =
      '<svg class="bp-trust__svg" viewBox="0 0 32 32" fill="none" aria-hidden="true">' +
        '<path d="M9 9.5c-.6 1.4-1.4 3.2-1.8 4.6-.2.6.2 1 .8.95 1.6-.1 4.1-.4 5.6-.6" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" stroke-linecap="round"/>' +
        '<path d="M7.4 14c1.6-3.6 5.4-7.2 9.8-7.1 5 .1 9.3 4.3 9.2 9.6-.1 5.2-4.4 9.2-9.6 9.1-3.8-.05-7-2.3-8.4-5.5" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" stroke-linecap="round"/>' +
      '</svg>';

    el.innerHTML =
      '<div class="bp-trust__row">' +
        '<div class="bp-trust__item"><span class="bp-trust__ico">' + icoBolt + '</span>48hr shipping</div>' +
        '<div class="bp-trust__item"><span class="bp-trust__ico">' + icoLock + '</span>Secure checkout</div>' +
        '<div class="bp-trust__item"><span class="bp-trust__ico">' + icoReturn + '</span>Easy returns</div>' +
      '</div>';
    anchor.parentNode.insertBefore(el, anchor.nextSibling);
  }

  // Detect the PRE-ORDER state for the currently selected variant.
  // product.js does NOT expose inventory_policy / inventory_quantity, so an
  // oversold (pre-order) variant looks identical to an in-stock one there:
  // both report available === true. The reliable signal is the Restock
  // Rocket app's injected "Preorder" button, which only appears for
  // oversold variants. We also fall back to any visible buy button whose
  // label reads "pre-order".
  function bpIsPreorder() {
    if (window.__bpForcePreorder) return true;
    if (window.__bpMapPreorder && window.__bpMapPreorder()) return true;
    var rr = document.querySelectorAll('.restock-rocket-preorder-button, [class*="restock-rocket"][class*="preorder"]');
    for (var i = 0; i < rr.length; i++) {
      var b = rr[i];
      var cs = window.getComputedStyle(b);
      if (cs.display !== 'none' && cs.visibility !== 'hidden' && b.offsetParent !== null) return true;
    }
    var cands = document.querySelectorAll("button[name='add'], .add-to-cart-button");
    for (var j = 0; j < cands.length; j++) {
      var c = cands[j];
      var ccs = window.getComputedStyle(c);
      if (ccs.display === 'none' || c.offsetParent === null) continue;
      if (/pre[\s-]?order/i.test(c.textContent || '')) return true;
    }
    return false;
  }

  function renderStatus(p, variant) {
    var status = document.querySelector('#bp-benefits .bp-benefits__status');
    if (!status) return;
    var dot = status.querySelector('.bp-benefits__pulse');
    var text = status.querySelector('.bp-benefits__status-text');
    if (!text) return;

    // Determine availability. If a specific variant is selected, use it.
    // Otherwise fall back to whether the product has ANY available variant.
    var available;
    if (variant) {
      available = !!variant.available;
    } else {
      available = !!(p && p.available);
    }
    var preorder = available && bpIsPreorder();

    status.classList.remove('bp-benefits__status--out', 'bp-benefits__status--preorder', 'bp-benefits__status--in');

    if (!available) {
      status.classList.add('bp-benefits__status--out');
      text.textContent = 'Sold out — restocking soon';
      if (dot) dot.style.background = '#ff4d4d';
    } else if (preorder) {
      status.classList.add('bp-benefits__status--preorder');
      text.textContent = 'Pre-order — ships when restocked';
      if (dot) dot.style.background = '#ffb020';
    } else {
      status.classList.add('bp-benefits__status--in');
      text.textContent = 'In stock & ready to ship';
      if (dot) dot.style.background = '#34d058';
    }
  }

  function update() {
    getProduct().then(function (p) {
      if (!p) return;
      var vid = currentVariantId();
      var variant = null;
      if (vid) {
        for (var i = 0; i < p.variants.length; i++) {
          if (p.variants[i].id === vid) { variant = p.variants[i]; break; }
        }
      }
      if (!variant && p.variants.length === 1) variant = p.variants[0];
      renderLowStock(variant);
      renderStatus(p, variant);
    });
  }

  function start() {
    if (!handle()) return;
    renderBenefits();
    renderTrust();
    update();
    // The Restock Rocket pre-order button is injected by the app and can
    // arrive a moment after this runs. Re-evaluate a few times so the badge
    // flips to PRE-ORDER once that button appears (then stop polling).
    var _n = 0;
    var _iv = setInterval(function () { update(); if (++_n >= 10) clearInterval(_iv); }, 400);
    document.addEventListener('change', function (e) {
      if (e.target && (e.target.closest('variant-picker') || e.target.matches('[name="id"]') || e.target.closest('.variant-option'))) {
        setTimeout(update, 80);
      }
    });
    document.addEventListener('variant:update', function () { setTimeout(update, 80); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();



/* ============================================================
   BLANKPILL — Estimated delivery badge (all product pages)
   Injects a pulsing "Order now → get it by <date range>" badge
   directly under the Add to Cart button. Date range is computed
   live: ships in 48hr + 3–6 day transit, skipping to a realistic
   window. Pulse = acid dot, matches the low-stock urgency style.
   Reversible: remove this block.
   ============================================================ */
(function () {
  'use strict';

  function pdpHandle() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function fmt(d) {
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  // Detect the PRE-ORDER state on this PDP. The Restock Rocket app only
  // injects its "Preorder" button for oversold (pre-order) variants, so it
  // is the reliable per-variant signal (product.js exposes no policy/qty).
  function etaPreorder() {
    if (window.__bpForcePreorder) return true;
    if (window.__bpMapPreorder && window.__bpMapPreorder()) return true;
    var rr = document.querySelector('.restock-rocket-preorder-button, [class*="restock-rocket"][class*="preorder"]');
    if (rr) {
      var cs = getComputedStyle(rr);
      if (cs.display !== 'none' && cs.visibility !== 'hidden' && rr.offsetParent !== null) return true;
    }
    var cands = document.querySelectorAll("button[name='add'], .add-to-cart-button");
    for (var i = 0; i < cands.length; i++) {
      var c = cands[i];
      if (getComputedStyle(c).display === 'none' || c.offsetParent === null) continue;
      if (/pre[\s-]?order/i.test(c.textContent || '')) return true;
    }
    return false;
  }

  // In-stock: ships in ~2 business days + 3–6 days transit (5–9 days).
  // Pre-order: made-to-order / restock window of 6–8 weeks (42–56 days).
  function deliveryRange(pre) {
    var now = new Date();
    var start = new Date(now);
    var end = new Date(now);
    if (pre) {
      start.setDate(start.getDate() + 42);
      end.setDate(end.getDate() + 56);
    } else {
      start.setDate(start.getDate() + 5);
      end.setDate(end.getDate() + 9);
    }
    return { start: start, end: end };
  }

  function atcWrapper() {
    // The Add to Cart button + its closest block wrapper. This is the
    // conventional spot for a delivery estimate: directly above ATC,
    // at the buy decision — where most stores place it.
    var atc =
      document.querySelector('add-to-cart-component') ||
      document.querySelector("button[name='add']") ||
      document.querySelector('.add-to-cart-button') ||
      document.querySelector('[data-testid="standalone-add-to-cart"]');
    if (!atc) return null;
    return atc.closest('add-to-cart-component, .buy-buttons-block, product-form-component') || atc;
  }

  function renderETA() {
    var target = atcWrapper();
    if (!target) {
      // Fallback to the buy/form block if ATC isn't found.
      target = document.querySelector('.buy-buttons-block, product-form-component, .product-form');
    }
    if (!target) return;

    var pre = etaPreorder();
    var mode = pre ? 'pre' : 'std';
    var existing = document.getElementById('bp-eta');
    // Already placed AND showing the right mode → keep.
    if (existing && existing.getAttribute('data-mode') === mode && document.getElementById('bp-freeship')) return;
    if (existing) existing.remove();

    var el = document.createElement('div');
    el.id = 'bp-eta';
    el.className = 'bp-eta';
    el.setAttribute('data-mode', mode);

    if (pre) {
      // Pre-order items: made-to-order / restock window of 6–8 weeks.
      el.innerHTML =
        '<span class="bp-eta__dot"></span>' +
        '<span class="bp-eta__text">Pre-order → ships in <strong>6–8 weeks</strong></span>';
    } else {
      var r = deliveryRange(false);
      el.innerHTML =
        '<span class="bp-eta__dot"></span>' +
        '<span class="bp-eta__text">Order now → get it <strong>' +
        fmt(r.start) + ' – ' + fmt(r.end) + '</strong></span>';
    }

    // Insert directly BEFORE the Add to Cart block so the estimate sits
    // right above the buy button (the conventional, high-converting spot).
    target.parentNode.insertBefore(el, target);

    // Separate, trustworthy "free shipping" badge directly below the ETA box.
    if (!document.getElementById('bp-freeship-css')) {
      var fcss = document.createElement('style');
      fcss.id = 'bp-freeship-css';
      fcss.textContent = '.bp-freeship{display:flex;align-items:center;justify-content:center;gap:8px;margin:8px 0 0;padding:10px 14px;border:1px solid #2c2c2c;border-radius:12px;background:#161616;color:#dcdad5;font:600 13px/1.2 inherit;letter-spacing:.2px}.bp-freeship strong{color:#e8f65c;font-weight:800}.bp-freeship__ico{display:inline-flex;flex:0 0 auto}.bp-freeship__ico svg{width:18px;height:18px}';
      document.head.appendChild(fcss);
    }
    var ship = document.getElementById('bp-freeship');
    if (!ship) {
      ship = document.createElement('div');
      ship.id = 'bp-freeship';
      ship.className = 'bp-freeship';
      ship.innerHTML = '<span class="bp-freeship__ico"><svg viewBox="0 0 24 24" fill="none" stroke="#e8f65c" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M1 3h13v10H1z"></path><path d="M14 7h4l3 3v3h-7z"></path><circle cx="5.5" cy="17.5" r="1.9"></circle><circle cx="17.5" cy="17.5" r="1.9"></circle></svg></span><span>Free worldwide shipping over <strong>$60</strong></span>';
    }
    target.parentNode.insertBefore(ship, target);
  }

  function start() {
    if (!pdpHandle()) return;
    // The buy block + Restock Rocket pre-order button can render slightly
    // late; re-run for a few seconds so the estimate seats above the ATC
    // and flips to the 6–8 week window once the pre-order button appears.
    var tries = 0;
    (function attempt() {
      tries++;
      renderETA();
      if (tries < 25) setTimeout(attempt, 200);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();



/* ============================================================
   BLANKPILL — Back in Stock "Notify me" (Klaviyo)
   On SOLD-OUT variants, injects a "Notify me when it's back"
   button under the SOLD OUT button. Clicking reveals an email
   field; submitting posts to Klaviyo's Back-in-Stock subscribe
   endpoint with the variant id + email, using the public site
   key. Klaviyo stores the signup; the actual restock email is
   sent by a Back-in-Stock FLOW the store owner builds in the
   Klaviyo dashboard (cannot be done from theme code).
   Public key is safe to expose — it is front-end by design.
   Reversible: remove this block.
   ============================================================ */
(function () {
  'use strict';

  var KLAVIYO_PUBLIC_KEY = 'W25tiS';

  function pdpHandle() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  // Use the shared, de-duped fetch (one request per page for all modules).
  function getProduct() {
    return window.__bpProductFetch();
  }

  function selectedVariantId() {
    var input = document.querySelector('input[name="id"], select[name="id"], [name="id"]');
    if (input && input.value) return parseInt(input.value, 10);
    var u = new URL(window.location.href);
    if (u.searchParams.get('variant')) return parseInt(u.searchParams.get('variant'), 10);
    return null;
  }

  function findVariant(p) {
    var vid = selectedVariantId();
    if (vid) {
      for (var i = 0; i < p.variants.length; i++) {
        if (p.variants[i].id === vid) return p.variants[i];
      }
    }
    if (p.variants.length === 1) return p.variants[0];
    return null;
  }

  function emailValid(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }

  // POST to Klaviyo Back in Stock — CLIENT endpoint (per Klaviyo docs).
  // Correct URL: /client/back-in-stock-subscriptions/?company_id=PUBLIC_KEY
  // JSON body, revision header, and the variant id MUST be in Klaviyo's
  // Shopify catalog format: $shopify:::$default:::<numericVariantId>.
  function subscribe(variantId, email) {
    var url = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' +
      encodeURIComponent(KLAVIYO_PUBLIC_KEY);
    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantId
            }
          }
        }
      }
    };
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-02-15'
      },
      body: JSON.stringify(payload)
    }).then(function (r) {
      // Success is 200/201/202 with no body. Anything else = failure.
      return r.ok;
    });
  }

  function removeUI() {
    var x = document.getElementById('bp-bis');
    if (x) x.remove();
  }

  function closeModal() {
    var m = document.getElementById('bp-bis-modal');
    if (m) m.remove();
    document.removeEventListener('keydown', onEsc);
  }

  function onEsc(e) {
    if (e.key === 'Escape') closeModal();
  }

  function openModal(variant) {
    if (document.getElementById('bp-bis-modal')) return;

    var modal = document.createElement('div');
    modal.id = 'bp-bis-modal';
    modal.className = 'bp-bis-modal';
    modal.innerHTML =
      '<div class="bp-bis-modal__overlay"></div>' +
      '<div class="bp-bis-modal__box" role="dialog" aria-modal="true" aria-label="Notify me when back in stock">' +
        '<button type="button" class="bp-bis-modal__close" aria-label="Close">\u00d7</button>' +
        '<div class="bp-bis-modal__bell">🔔</div>' +
        '<h3 class="bp-bis-modal__title">Notify me when it\u2019s back</h3>' +
        '<p class="bp-bis-modal__sub">Drop your email and we\u2019ll ping you the second it restocks.</p>' +
        '<input type="email" class="bp-bis__email" placeholder="you@email.com" autocomplete="email" inputmode="email" />' +
        '<button type="button" class="bp-bis__submit">Notify me</button>' +
        '<p class="bp-bis__msg" role="status"></p>' +
      '</div>';
    document.body.appendChild(modal);
    document.addEventListener('keydown', onEsc);

    var overlay = modal.querySelector('.bp-bis-modal__overlay');
    var closeBtn = modal.querySelector('.bp-bis-modal__close');
    var emailEl = modal.querySelector('.bp-bis__email');
    var submit = modal.querySelector('.bp-bis__submit');
    var msg = modal.querySelector('.bp-bis__msg');
    var box = modal.querySelector('.bp-bis-modal__box');

    overlay.addEventListener('click', closeModal);
    closeBtn.addEventListener('click', closeModal);
    setTimeout(function () { emailEl.focus(); }, 50);

    function doSubmit() {
      var email = (emailEl.value || '').trim();
      msg.classList.remove('bp-bis__msg--ok', 'bp-bis__msg--err');
      if (!emailValid(email)) {
        msg.textContent = 'Enter a valid email.';
        msg.classList.add('bp-bis__msg--err');
        return;
      }
      submit.disabled = true;
      submit.textContent = 'Saving…';
      subscribe(variant.id, email).then(function (ok) {
        if (ok) {
          box.innerHTML =
            '<button type="button" class="bp-bis-modal__close" aria-label="Close">\u00d7</button>' +
            '<div class="bp-bis-modal__bell">\u2713</div>' +
            '<h3 class="bp-bis-modal__title">You\u2019re on the list</h3>' +
            '<p class="bp-bis-modal__sub">We\u2019ll email you the second it\u2019s back in stock.</p>';
          box.querySelector('.bp-bis-modal__close').addEventListener('click', closeModal);
        } else {
          submit.disabled = false;
          submit.textContent = 'Notify me';
          msg.textContent = 'Something went wrong — try again.';
          msg.classList.add('bp-bis__msg--err');
        }
      }).catch(function () {
        submit.disabled = false;
        submit.textContent = 'Notify me';
        msg.textContent = 'Something went wrong — try again.';
        msg.classList.add('bp-bis__msg--err');
      });
    }

    submit.addEventListener('click', doSubmit);
    emailEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); doSubmit(); }
    });
  }

  function buildUI(variant) {
    removeUI();

    // Anchor: under the SOLD OUT add-to-cart button.
    var anchor =
      document.querySelector('add-to-cart-component') ||
      document.querySelector('.add-to-cart-button') ||
      document.querySelector("button[name='add']") ||
      document.querySelector('.buy-buttons-block, product-form-component, .product-form');
    if (!anchor) return;

    // Single button only. No inline form — clicking opens a popup modal.
    var wrap = document.createElement('div');
    wrap.id = 'bp-bis';
    wrap.className = 'bp-bis';
    wrap.innerHTML =
      '<button type="button" class="bp-bis__toggle">' +
        '<span class="bp-bis__bell">🔔</span> Notify me when it\u2019s back' +
      '</button>';

    var insertAfter = anchor.closest('add-to-cart-component, .buy-buttons-block, product-form-component') || anchor;
    insertAfter.parentNode.insertBefore(wrap, insertAfter.nextSibling);

    wrap.querySelector('.bp-bis__toggle').addEventListener('click', function () {
      openModal(variant);
    });
  }

  function soldOutButton() {
    // The actual SOLD OUT add-to-cart button on this PDP.
    return document.querySelector(
      "button[name='add'], .add-to-cart-button, [data-testid='standalone-add-to-cart']"
    );
  }

  function evaluate() {
    if (!pdpHandle()) return;
    getProduct().then(function (p) {
      if (!p) return;
      var v = findVariant(p);
      var trust = document.getElementById('bp-trust');
      var soldBtn = soldOutButton();
      // Show BIS only when the selected variant is unavailable.
      if (v && !v.available) {
        buildUI(v);
        // REPLACE the SOLD OUT button: hide it so the acid Notify Me
        // button sits in its place (not stacked below it).
        if (soldBtn) {
          var soldWrap = soldBtn.closest('add-to-cart-component') || soldBtn;
          soldWrap.style.display = 'none';
        }
        // Hide the trust row on sold-out — it repeats info and
        // "SHIPS IN 48HR" is misleading under a SOLD OUT item.
        if (trust) trust.style.display = 'none';
      } else {
        removeUI();
        if (soldBtn) {
          var sw = soldBtn.closest('add-to-cart-component') || soldBtn;
          sw.style.display = '';
        }
        if (trust) trust.style.display = '';
      }
    });
  }

  function start() {
    evaluate();
    document.addEventListener('change', function (e) {
      if (e.target && (e.target.closest('variant-picker') || e.target.matches('[name="id"]') || e.target.closest('.variant-option'))) {
        setTimeout(evaluate, 90);
      }
    });
    document.addEventListener('variant:update', function () { setTimeout(evaluate, 90); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();




/* ============================================================
   BLANKPILL — Size guide link at the buy box
   Injects a "Size guide" link right above the variant picker on
   product pages. Clicking opens a modal with the size-guide page
   content (fetched from /pages/size-guide) so the shopper never
   leaves the product page. Falls back to opening the page in a
   new tab if the fetch/parse fails. Self-contained styles.
   Reversible: remove this block.
   ============================================================ */
(function () {
  'use strict';
  if (!/\/products\//.test(window.location.pathname)) return;

  var LINK_ID = 'bp-sizeguide-link';
  var PAGE_URL = '/pages/size-guide';

  function injectStyle() {
    if (document.getElementById('bp-sizeguide-css')) return;
    var s = document.createElement('style');
    s.id = 'bp-sizeguide-css';
    s.textContent =
      '.bp-sizeguide{margin:0 0 6px}' +
      '.bp-sizeguide__btn{display:inline-flex;align-items:center;gap:6px;background:none;border:none;padding:4px 0;font:600 13px/1.2 inherit;color:inherit;cursor:pointer;text-decoration:underline;text-underline-offset:3px}' +
      '.bp-sizeguide__ico{width:18px;height:18px;flex:0 0 auto}' +
      '.bp-sg-modal{position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center}' +
      '.bp-sg-modal__overlay{position:absolute;inset:0;background:rgba(0,0,0,.55)}' +
      '.bp-sg-modal__box{position:relative;background:#fff;color:#111;max-width:680px;width:92%;max-height:85vh;overflow:auto;border-radius:14px;padding:30px 24px;box-shadow:0 20px 60px rgba(0,0,0,.35)}' +
      '.bp-sg-modal__close{position:absolute;top:8px;right:14px;background:none;border:none;font-size:28px;line-height:1;cursor:pointer;color:#111}' +
      '.bp-sg-modal__loading{font:500 14px/1.4 inherit;color:#666}' +
      '.bp-sg-modal__body img{max-width:100%;height:auto}' +
      '.bp-sg-modal__body table{width:100%;border-collapse:collapse;margin:10px 0}' +
      '.bp-sg-modal__body th,.bp-sg-modal__body td{border:1px solid #e6e6e6;padding:7px 9px;text-align:center;font-size:14px}' +
      'shopify-payment-terms:empty,.installments:empty,product-price .installments:empty,product-price form.payment-terms:empty{display:none!important;margin:0!important;padding:0!important}';
    document.head.appendChild(s);
  }

  function findAnchor() {
    return document.querySelector(
      'variant-picker, variant-picker-component, .variant-picker, [class*="variant-picker"], .variant-option, fieldset[class*="variant"]'
    ) || document.querySelector(
      'add-to-cart-component, .buy-buttons-block, product-form-component, .product-form'
    );
  }

  function injectLink() {
    return; /* replaced by the theme's Size Guide popup block rendered directly under the Size selector */
    if (document.getElementById(LINK_ID)) return;
    var _hay = (window.__bpProductData ? ((window.__bpProductData.type || '') + ' ' + (window.__bpProductData.title || '')) : '') + ' ' + (document.title || '');
    if (/plush/i.test(_hay)) return; /* apparel size guide is not relevant on plushies */
    var anchor = findAnchor();
    if (!anchor) return;
    injectStyle();
    var wrap = document.createElement('div');
    wrap.id = LINK_ID;
    wrap.className = 'bp-sizeguide';
    wrap.innerHTML =
      '<button type="button" class="bp-sizeguide__btn">' +
        '<svg class="bp-sizeguide__ico" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
          '<path d="M3 8h18v8H3z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
          '<path d="M7 8v3M11 8v4M15 8v3M19 8v4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
        '</svg>' +
        'Size guide' +
      '</button>';
    anchor.parentNode.insertBefore(wrap, anchor);
    wrap.querySelector('.bp-sizeguide__btn').addEventListener('click', openModal);
  }

  function closeModal() {
    var m = document.getElementById('bp-sizeguide-modal');
    if (m) m.remove();
    document.removeEventListener('keydown', onEsc);
  }
  function onEsc(e) { if (e.key === 'Escape') closeModal(); }

  function openModal() {
    if (document.getElementById('bp-sizeguide-modal')) return;
    var modal = document.createElement('div');
    modal.id = 'bp-sizeguide-modal';
    modal.className = 'bp-sg-modal';
    modal.innerHTML =
      '<div class="bp-sg-modal__overlay"></div>' +
      '<div class="bp-sg-modal__box" role="dialog" aria-modal="true" aria-label="Size guide">' +
        '<button type="button" class="bp-sg-modal__close" aria-label="Close">×</button>' +
        '<div class="bp-sg-modal__body"><p class="bp-sg-modal__loading">Loading size guide…</p></div>' +
      '</div>';
    document.body.appendChild(modal);
    document.addEventListener('keydown', onEsc);
    modal.querySelector('.bp-sg-modal__overlay').addEventListener('click', closeModal);
    modal.querySelector('.bp-sg-modal__close').addEventListener('click', closeModal);

    var body = modal.querySelector('.bp-sg-modal__body');
    fetch(PAGE_URL, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content =
          doc.querySelector('.shopify-section main') ||
          doc.querySelector('main .rte') ||
          doc.querySelector('#MainContent') ||
          doc.querySelector('main');
        if (!content) throw new Error('no content');
        body.innerHTML = '';
        body.appendChild(document.importNode(content, true));
      })
      .catch(function () {
        closeModal();
        window.open(PAGE_URL, '_blank', 'noopener');
      });
  }

  function start() { injectLink(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
  [300, 800, 1500].forEach(function (ms) { setTimeout(injectLink, ms); });
})();




/* ============================================================
   BLANKPILL — "Buy 2 tees, 10% off" bundle note (tee PDPs only)
   Shows a small bundle callout above the buy box on T-shirt
   product pages, matching the automatic "Buy 2 Tees, Get 10% Off"
   Shopify discount. Detects tees via product type/title.
   Self-contained styles. Reversible: remove this block.
   ============================================================ */
(function () {
  'use strict';
  if (!/\/products\//.test(window.location.pathname)) return;
  if (!window.__bpProductFetch) return;

  function injectStyle() {
    if (document.getElementById('bp-bundle-css')) return;
    var s = document.createElement('style');
    s.id = 'bp-bundle-css';
    s.textContent =
      '.bp-bundle-note{margin:0 0 12px;padding:10px 13px;border:1px solid #111;border-radius:10px;background:#e8f65c;font:600 13px/1.35 inherit;color:#080808}' +
      '.bp-bundle-note strong{font-weight:800}';
    document.head.appendChild(s);
  }

  window.__bpProductFetch().then(function (p) {
    if (!p) return;
    if (document.getElementById('bp-bundle-note')) return;
    return; /* bundle note now rendered inside the theme block 'bundle-quick-add', directly above Add to Cart */
    var hay = ((p.type || '') + ' ' + (p.title || '')).toLowerCase();
    var noun = 'items', pct = '10%';
    if (hay.indexOf('hood') !== -1) { noun = 'hoodies'; pct = '15%'; }
    else if (hay.indexOf('plush') !== -1) { noun = 'plushies'; pct = '10%'; }
    else if (hay.indexOf('shirt') !== -1 || hay.indexOf('tee') !== -1) { noun = 'tees'; pct = '10%'; }
    var anchor = document.querySelector('add-to-cart-component, .buy-buttons-block, product-form-component, .product-form');
    if (!anchor) return;
    injectStyle();
    var el = document.createElement('div');
    el.id = 'bp-bundle-note';
    el.className = 'bp-bundle-note';
    el.innerHTML = '<strong>Bundle &amp; save:</strong> add any 2 ' + noun + ' and get <strong>' + pct + ' off</strong> — applied automatically at checkout.';
    anchor.parentNode.insertBefore(el, anchor);
  }).catch(function () {});
})();




/* ============================================================
   BLANKPILL — Product page Save % pill + red compare-at price.
   Shows a red "Save X%" pill next to the price (per selected
   variant) and forces the struck compare-at price red.
   Reversible: remove this block.
   ============================================================ */
(function () {
  'use strict';
  if (!/\/products\//.test(window.location.pathname)) return;
  if (!window.__bpProductFetch) return;

  function injectStyle() {
    if (document.getElementById('bp-pdp-save-css')) return;
    var s = document.createElement('style');
    s.id = 'bp-pdp-save-css';
    s.textContent =
      '.bp-pdp-save{display:inline-block;margin:0;background:#d61f1f;color:#fff;font-weight:800;font-size:12px;padding:2px 8px;border-radius:6px;vertical-align:baseline;letter-spacing:.02em;line-height:1.45}' +
      '.product-information .price__sale,.price .price__sale{display:flex !important;flex-wrap:wrap;align-items:baseline;gap:4px 10px}' +
      'product-price s,.price s,.price del,.price__compare,.compare-at-price{color:#d61f1f !important}';
    document.head.appendChild(s);
  }

  function currentVid() {
    var i = document.querySelector('[name="id"]');
    if (i && i.value) return parseInt(i.value, 10);
    var u = new URL(window.location.href);
    if (u.searchParams.get('variant')) return parseInt(u.searchParams.get('variant'), 10);
    return null;
  }

  function forceRedCompare() {
    document.querySelectorAll('.compare-at-price, .price s, .price del, s.price-item--regular, .price-item--regular.compare-at-price').forEach(function (e) {
      e.style.setProperty('color', '#d61f1f', 'important');
    });
  }

  function getPill() {
    var hosts = [].slice.call(document.querySelectorAll('.price__sale'));
    var host = hosts.filter(function (e) { return e.offsetParent !== null && e.getBoundingClientRect().height > 0; })[0] || hosts[0] || document.querySelector('product-price .price') || document.querySelector('product-price') || document.querySelector('.price');
    if (!host) return null;
    var pill = document.getElementById('bp-pdp-save');
    if (pill) { if (pill.parentNode !== host) host.appendChild(pill); return pill; }
    pill = document.createElement('span');
    pill.id = 'bp-pdp-save';
    pill.className = 'bp-pdp-save';
    host.appendChild(pill);
    return pill;
  }

  function ensurePillIn(host, pct, show) {
    var pill = host.querySelector('.bp-pdp-save');
    if (show) {
      if (!pill) { pill = document.createElement('span'); pill.className = 'bp-pdp-save'; host.appendChild(pill); }
      pill.textContent = 'Save ' + pct + '%';
      pill.style.display = '';
    } else if (pill) {
      pill.style.display = 'none';
    }
  }

  function update() {
    forceRedCompare();
    window.__bpProductFetch().then(function (p) {
      if (!p) return;
      var v = null, id = currentVid();
      if (id) { for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].id === id) { v = p.variants[i]; break; } } }
      if (!v && p.variants.length === 1) v = p.variants[0];
      var cmp = v && v.compare_at_price, price = v && v.price;
      var show = !!(v && cmp && cmp > price);
      var pct = show ? Math.round((cmp - price) / cmp * 100) : 0;
      var hosts = [].slice.call(document.querySelectorAll('.price__sale')).filter(function (h) {
        return !h.closest('product-card, .product-card, .bp-product-card, product-recommendations, .product-recommendations, .product-card-link');
      });
      if (hosts.length) {
        hosts.forEach(function (h) { ensurePillIn(h, pct, show); });
      } else {
        var pe = document.querySelector('product-price .price') || document.querySelector('product-price') || document.querySelector('.price');
        if (pe) ensurePillIn(pe, pct, show);
      }
      forceRedCompare();
    }).catch(function () {});
  }

  function start() {
    injectStyle();
    update();
    document.addEventListener('change', function (e) {
      if (e.target && (e.target.closest('variant-picker') || e.target.matches('[name="id"]') || e.target.closest('.variant-option'))) setTimeout(update, 90);
    });
    document.addEventListener('variant:update', function () { setTimeout(update, 90); });
    [500, 1500].forEach(function (ms) { setTimeout(update, ms); });
    try {
      var t = null;
      var mo = new MutationObserver(function () { if (t) return; t = setTimeout(function () { t = null; update(); }, 150); });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();




/* ============================================================
   BLANKPILL — Move benefits list + status pulse badge above the
   variant picker on product pages that have one (shirts/hoodies),
   so they sit right under the price like single-variant plushie
   pages do. Reversible: remove this block.
   ============================================================ */
(function () {
  'use strict';
  if (!/\/products\//.test(window.location.pathname)) return;

  function reposition() {
    var ben = document.getElementById('bp-benefits');
    var vp = document.querySelector('variant-picker, variant-picker-component, [class*="variant-picker"]');
    if (!ben || !vp) return;
    // Only act if benefits currently come AFTER the variant picker.
    if (vp.compareDocumentPosition(ben) & Node.DOCUMENT_POSITION_FOLLOWING) {
      var sg = document.getElementById('bp-sizeguide-link');
      var target = (sg && sg.parentNode === vp.parentNode) ? sg : vp;
      if (target && target.parentNode) target.parentNode.insertBefore(ben, target);
    }
  }

  function start() {
    reposition();
    [200, 600, 1200, 2200].forEach(function (ms) { setTimeout(reposition, ms); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();



/* ============================================================
   BLANKPILL — Acid PRE-ORDER button on product pages
   The Restock Rocket app injects a bland dark "Pre-order" button
   in place of Add to Cart on oversold variants. This restyles it
   to match the acid Add-to-Cart / home-page buttons. Scoped to
   the buy area only (never touches product cards). Reversible:
   remove this block.
   ============================================================ */
(function () {
  'use strict';
  if (!/\/products\//.test(window.location.pathname)) return;

  function inBuyArea(el) {
    return !!el.closest('product-form-component, .product-form-buttons, .buy-buttons-block, .product-details, add-to-cart-component') &&
      !el.closest('product-card, .product-card, .bp-product-card, product-recommendations, .product-recommendations, .bp-product-card-link, a.bp-product-card-link');
  }

  function injectCss() {
    if (document.getElementById('bp-preorder-css')) return;
    var st = document.createElement('style');
    st.id = 'bp-preorder-css';
    st.textContent =
      '.bp-preorder-acid:hover{box-shadow:0 8px 22px rgba(232,255,0,.32),0 0 0 1px rgba(232,255,0,.85)!important}' +
      '@keyframes bpAtcPulse{0%,100%{transform:scale(1)}50%{transform:scale(1.012)}}';
    document.head.appendChild(st);
  }
  function paint(el) {
    injectCss();
    el.classList.add('bp-preorder-acid');
    var s = el.style;
    // Inline !important beats the app's dark inline/high-specificity styles.
    s.setProperty('background', '#e8ff00', 'important');
    s.setProperty('background-color', '#e8ff00', 'important');
    s.setProperty('background-image', 'none', 'important');
    s.setProperty('color', '#080808', 'important');
    s.setProperty('border', 'none', 'important');
    s.setProperty('border-radius', '100px', 'important');
    s.setProperty('font-weight', '800', 'important');
    s.setProperty('letter-spacing', '.5px', 'important');
    s.setProperty('text-transform', 'uppercase', 'important');
    s.setProperty('box-shadow', '0 4px 10px rgba(0,0,0,.25),0 0 0 1px rgba(232,255,0,.65)', 'important');
    s.setProperty('opacity', '1', 'important');
    s.setProperty('cursor', 'pointer', 'important');
    s.setProperty('animation', 'bpAtcPulse 2s ease-in-out infinite', 'important');
    s.setProperty('transition', 'transform .25s ease, box-shadow .25s ease', 'important');
    Array.prototype.forEach.call(el.querySelectorAll('*'), function (c) {
      c.style.setProperty('color', '#080808', 'important');
    });
  }

  function run() {
    // Only actual buttons — never wrapper containers (which caused a giant yellow blob).
    var nodes = document.querySelectorAll('button.restock-rocket-preorder-button, button.add-to-cart-button, button[name="add"], input[type="submit"], a.add-to-cart-button');
    Array.prototype.forEach.call(nodes, function (el) {
      var tag = el.tagName;
      if (tag !== 'BUTTON' && tag !== 'INPUT' && tag !== 'A') return;
      var t = (el.textContent || el.value || '').trim();
      var r = el.getBoundingClientRect();
      if (/pre[\s-]?order/i.test(t) && r.height > 34 && r.height < 90 && r.width > 120 && el.offsetParent !== null && inBuyArea(el)) {
        paint(el);
      }
    });
  }

  function start() {
    run();
    // Restock Rocket can inject its button a moment after load — poll briefly.
    var n = 0;
    var iv = setInterval(function () { run(); if (++n >= 25) clearInterval(iv); }, 280);
    document.addEventListener('variant:update', function () { setTimeout(run, 120); });
    document.addEventListener('change', function (e) {
      if (e.target && (e.target.closest('variant-picker') || e.target.matches('[name="id"]') || e.target.closest('.variant-option'))) setTimeout(run, 150);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();



/* ============================================================
   BLANKPILL — Acid ADD TO CART restore (PDP buy box only)
   Replaces the dropped Section Store "atc-style" app block:
   acid gradient + pulse animation + arrow, and appends the live
   variant price with struck compare-at. Variant-aware.
   Never touches product cards, sold-out or pre-order buttons
   (those have their own modules). Reversible: remove this block.
   ============================================================ */
(function () {
  'use strict';
  if (!/\/products\//.test(window.location.pathname)) return;

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function injectCss() {
    if (document.getElementById('bp-atc-acid-css')) return;
    var s = document.createElement('style');
    s.id = 'bp-atc-acid-css';
    s.textContent =
      '@keyframes bpAtcPulse{0%,100%{transform:scale(1)}50%{transform:scale(1.012)}}' +
      'button.bp-atc-acid{background:linear-gradient(180deg,#f4ff70,#e8f65c)!important;background-color:#e8f65c!important;color:#080808!important;border:none!important;border-radius:100px!important;font-weight:800!important;letter-spacing:.5px!important;text-transform:uppercase!important;box-shadow:0 6px 18px rgba(232,255,0,.22),0 0 0 1px rgba(232,255,0,.6)!important;animation:bpAtcPulse 2s ease-in-out infinite!important;transition:box-shadow .25s ease!important;opacity:1!important}' +
      'button.bp-atc-acid:hover{box-shadow:0 8px 24px rgba(232,255,0,.35),0 0 0 1px rgba(232,255,0,.95)!important}' +
      'button.bp-atc-acid .add-to-cart-text,button.bp-atc-acid .add-to-cart-text *{color:#080808!important}' +
      'button.bp-atc-acid .svg-wrapper.add-to-cart-icon{display:none!important}' +
      'button.bp-atc-acid{position:relative}' +
      'button.bp-atc-acid[data-added="true"]{animation:none!important}' +
      'button.bp-atc-acid .add-to-cart__added{display:none!important}' +
      'button.bp-atc-acid[data-added="true"] .add-to-cart-text{animation:none!important}' +
      'button.bp-atc-acid.bp-added-flash .add-to-cart-text{opacity:0!important}' +
      'button.bp-atc-acid.bp-added-flash::after{content:"✓ ADDED";position:absolute;inset:0;display:flex;align-items:center;justify-content:center;color:#080808;font-weight:800;letter-spacing:.6px;text-transform:uppercase}' +
      'button.bp-atc-acid .bp-atc-arrow{margin-right:6px;font-weight:800}' +
      'button.bp-atc-acid .bp-atc-pricewrap{font-weight:800;white-space:nowrap}' +
      'button.bp-atc-acid .bp-atc-compare{margin-left:8px;text-decoration:line-through;opacity:.5;font-weight:700}';
    document.head.appendChild(s);
  }

  function atcButton() {
    var scope = document.querySelector('.product-information, .product-details') || document;
    var el = scope.querySelector("button[name='add'], button.add-to-cart-button");
    if (!el) return null;
    if (el.closest('product-card, .product-card, .bp-product-card, product-recommendations, .product-recommendations, quick-add-modal')) return null;
    return el;
  }

  function currentVariant(p) {
    var i = document.querySelector('[name="id"]');
    var id = (i && i.value) ? parseInt(i.value, 10) : null;
    if (!id) {
      var u = new URL(window.location.href);
      if (u.searchParams.get('variant')) id = parseInt(u.searchParams.get('variant'), 10);
    }
    if (id) { for (var k = 0; k < p.variants.length; k++) { if (p.variants[k].id === id) return p.variants[k]; } }
    if (p.variants.length === 1) return p.variants[0];
    return null;
  }

  function decorate() {
    var btn = atcButton();
    if (!btn) return;
    var label = (btn.textContent || '').trim();
    // Leave sold-out / pre-order states to their dedicated modules.
    if (/pre[\s-]?order|sold\s?out|unavailable/i.test(label)) {
      btn.classList.remove('bp-atc-acid');
      return;
    }
    injectCss();
    btn.classList.add('bp-atc-acid');

    // Failsafe: the theme resets data-added only after ALL subtree animations
    // settle, which other scripts on this page can keep alive indefinitely —
    // leaving the button stuck on the checkmark with no label. Force the
    // reset ourselves shortly after each add.
    if (!btn.__bpAtcReset) {
      btn.__bpAtcReset = true;
      btn.addEventListener('click', function () {
        btn.classList.add('bp-added-flash');
        setTimeout(function () { btn.classList.remove('bp-added-flash'); btn.removeAttribute('data-added'); }, 1600);
        setTimeout(function () { btn.classList.remove('bp-added-flash'); btn.removeAttribute('data-added'); }, 4000);
      });
    }

    // Horizon's button is display:grid (label + "Added" state stacked), so
    // our spans must live INSIDE the label span or they become grid rows.
    var host = btn.querySelector('.add-to-cart-text') || btn;
    // Arrow before the label (idempotent).
    if (!host.querySelector('.bp-atc-arrow')) {
      var arrow = document.createElement('span');
      arrow.className = 'bp-atc-arrow';
      arrow.textContent = '→';
      host.insertBefore(arrow, host.firstChild);
    }

    // Live price + struck compare-at (idempotent, variant-aware).
    if (!window.__bpProductFetch) return;
    window.__bpProductFetch().then(function (p) {
      if (!p) return;
      var v = currentVariant(p);
      var price = v ? v.price : p.price;
      var cmp = v ? v.compare_at_price : p.compare_at_price;
      if (typeof price !== 'number') return;
      var phost = btn.querySelector('.add-to-cart-text') || btn;
      var span = phost.querySelector('.bp-atc-pricewrap');
      if (!span) {
        span = document.createElement('span');
        span.className = 'bp-atc-pricewrap';
        phost.appendChild(span);
      }
      span.innerHTML = '&nbsp;- ' + money(price) +
        ((cmp && cmp > price) ? '<s class="bp-atc-compare">' + money(cmp) + '</s>' : '');
    }).catch(function () {});
  }

  function start() {
    decorate();
    // Theme re-renders the button text on variant change — re-decorate briefly.
    var n = 0;
    var iv = setInterval(function () { decorate(); if (++n >= 12) clearInterval(iv); }, 350);
    document.addEventListener('variant:update', function () { setTimeout(decorate, 120); });
    document.addEventListener('change', function (e) {
      if (e.target && (e.target.closest('variant-picker') || e.target.matches('[name="id"]') || e.target.closest('.variant-option'))) {
        setTimeout(decorate, 120);
      }
    });
    document.addEventListener('shopify:section:load', function () { setTimeout(decorate, 100); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();